<template>
  <customModal :containerxl="true" :bodymd="true" @closeModal="closeModal">
    <template #title>
      {{ isEditMode ? "Update Cohort" : "Create Cohort" }}
    </template>

    <template #body>
      <div v-if="loadingDetails" class="text-center py-4">
        <img src="../../assets/img/loading.gif" width="15" alt="Loading cohort" />
        <div class="mt-2">Loading cohort details...</div>
      </div>

      <div v-else class="row">
        <div class="col-12">
          <h5 class="section-title">Cohort Details</h5>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">
            Cohort Code
            <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input v-model="form.cohortCode" class="form-control" type="text" />
          <span v-if="errors.cohortCode" class="errormsg ml-0">{{ errors.cohortCode }}</span>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">
            Cohort Name
            <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input v-model="form.cohortName" class="form-control" type="text" />
          <span v-if="errors.cohortName" class="errormsg ml-0">{{ errors.cohortName }}</span>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">
            SoA ID
          </label>
         <select class="form-select" v-model="form.soAId">
            <option value="" disabled>Select</option>
 
            <option v-for="id in soaIds" :key="id" :value="id">
              {{ id }}
            </option>
          </select>
        </div>

        <div class="col-6 form-group mb-3">
          <label class="mb-0">Description</label>
          <textarea v-model="form.description" class="form-control" rows="2"></textarea>
        </div>

        <div class="col-12">
          <h5 class="section-title">Dose Details</h5>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Study Part</label>
          <select v-model="form.studyPart" class="form-control">
            <option value="" disabled>Select study part</option>
            <option value="Part A">Part A</option>
            <option value="Part B">Part B</option>
          </select>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Phase</label>
          <select v-model="form.phase" class="form-control">
            <option value="" disabled>Select phase</option>
            <option
              v-for="phase in phases"
              :key="phase"
              :value="phase"
            >
              {{ phase }}
            </option>
          </select>
          <small v-if="phaseLoadError" class="text-danger">{{ phaseLoadError }}</small>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Design Type</label>
          <select v-model="form.designType" class="form-control">
            <option value="" disabled>Select design type</option>
            <option value="SAD">SAD</option>
            <option value="MAD">MAD</option>
          </select>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Dose Amount</label>
          
            <input
                v-model.number="form.dose.amount"
                class="form-control"
                type="number"
                min="0"
                step="any"
                inputmode="decimal"
              />

          <!-- <input v-model.number="form.dose.amount" class="form-control" type="number" min="0" step="any" /> -->
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Unit</label>
          <select v-model="form.dose.unit" class="form-control">
            <option value="" disabled>Select unit</option>
            <option
              v-for="unit in dosageUnits"
              :key="unit"
              :value="unit"
            >
              {{ unit }}
            </option>
          </select>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Route</label>
          <select v-model="form.dose.route" class="form-control">
            <option value="" disabled>Select route</option>
            <option
              v-for="route in dosageRoutes"
              :key="route"
              :value="route"
            >
              {{ route }}
            </option>
          </select>
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="mb-0">Planned Subjects</label>
          <input v-model.number="form.plannedSubjects" class="form-control" type="number" min="0" />
        </div>
      </div>

      <div v-if="!loadingDetails" class="d-flex justify-content-end align-items-center mt-3">
        <button class="save_btn py-1 px-4" :disabled="submitting" @click="submitCohort">
          {{ submitting ? (isEditMode ? "Updating..." : "Creating...") : (isEditMode ? "Update Cohort" : "Create Cohort") }}
        </button>
      </div>
    </template>
  </customModal>
</template>
<script src="./createcohortmodel.js"></script>
<style scoped>
.section-title {
  font-size: 15px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
}
</style>
